const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.webm', '.ogv', '.ogg'];

/**
 * Checks whether a URL points to a video, based on its file extension.
 *
 * Detection is extension-based: the query string and hash are stripped, then the
 * pathname is matched against a known list of video extensions. URLs without a
 * recognizable extension (e.g. signed URLs or `?format=`-style URLs) will NOT be
 * detected as video.
 *
 * @param url - The URL to check.
 * @returns `true` if the URL ends in a known video extension, otherwise `false`.
 */
export const isVideoUrl = (url: string): boolean => {
    const pathname = url.split(/[?#]/)[0].toLowerCase();
    return VIDEO_EXTENSIONS.some((ext) => pathname.endsWith(ext));
};
